<script lang="ts">
  import { onMount } from "svelte"
  import Cropper from "svelte-easy-crop"
  import Modal from "$app/components/Modal.svelte"

  interface Props {
    open?: boolean
    image: string
    cropShape: string
    file: File
    btnText?: string
    modal?: boolean
    cropperClose: () => void
    imageCropped: (data: { image: string; file: File }) => void
  }

  let {
    open = false,
    image,
    cropShape,
    file,
    btnText = "Update Image",
    modal = true,
    cropperClose,
    imageCropped
  }: Props = $props()

  const maxZoom = 4
  const size = 300

  let zoom = 1
  let img = new Image()
  img.crossOrigin = "Anonymous"

  type cropperDataType = {
    height: number
    width: number
    x: number
    y: number
  }
  type cropperImgType = {
    percent: cropperDataType
    pixels: cropperDataType
  }

  let cropperData: cropperImgType

  /**
   * Creates a canvas with the image and resizes according to the image cropper
   * the canvas is used to generate the new image
   */
  function getCanvas(): HTMLCanvasElement {
    const canvas = document.createElement("canvas")
    canvas.width = size
    canvas.height = size
    const ctx = canvas.getContext("2d")

    const { width, height, x, y } = cropperData.percent

    const w = (100 / width) * size
    const h = (100 / height) * size

    const xp = -w * (x / 100)
    const yp = -(size / cropperData.pixels.height) * cropperData.pixels.y

    ctx.clearRect(0, 0, size, size)
    ctx.drawImage(img, xp, yp, w, h)

    return canvas
  }

  function closeAndSave(): void {
    cropperClose()
    open = false
    const canvas = getCanvas()
    canvas.toBlob((blob) => {
      const newFile = new File([blob], file.name, { type: file.type })
      imageCropped({
        image: canvas.toDataURL(file.type),
        file: newFile
      })
    }, file.type)
  }

  onMount(() => {
    img.src = image
  })
</script>

{#if modal}
  <Modal bind:open style="max-width: 350px !important;">
    <div id="image-cropper" style="width:{size}px;">
      <div class="text-gray-400 p-2 text-center">
        Scroll over the image to zoom
      </div>
      <div class="relative cropper-cont" style="width:{size}px;height:{size}px">
        <Cropper
          {image}
          aspect={1}
          {zoom}
          {cropShape}
          {maxZoom}
          oncropcomplete={(detail) => {
            cropperData = detail
          }}
        />
      </div>
      <button
        onclick={closeAndSave}
        class="btn success btn-big w-full mt-2 text-center font-bold inline-block"
      >
        {btnText}
      </button>
    </div>
  </Modal>
{:else}
  <div id="image-cropper" style="width:{size}px;">
    <div class="text-gray-400 p-2 text-center">
      Scroll over the image to zoom
    </div>
    <div class="relative cropper-cont" style="width:{size}px;height:{size}px">
      <Cropper
        {image}
        aspect={1}
        {zoom}
        {cropShape}
        {maxZoom}
        oncropcomplete={(detail) => {
          cropperData = detail
        }}
      />
    </div>
    <button
      onclick={closeAndSave}
      class="btn success btn-big w-full mt-2 font-bold inline-block"
    >
      {btnText}
    </button>
  </div>
{/if}

<style>
  .btn.success {
    justify-content: center;
  }
</style>
